export default "__VITE_ASSET__BEdZcT2m__"